import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTbExtrm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.6735 11.0044C14.7794 10.7926 15.0816 10.7926 15.1875 11.0044L22.4612 25.5519H27.2862C27.6036 25.5519 27.8609 25.8092 27.8609 26.1266V28.4253C27.8609 28.7427 27.6036 29 27.2862 29H2.57469C2.2573 29 2 28.7427 2 28.4253V26.1266C2 25.8092 2.2573 25.5519 2.57469 25.5519H7.3997L14.6735 11.0044Z",
		fill: "#CC00CC"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.4164 1.31768C14.6282 0.894107 15.2327 0.894107 15.4444 1.31768L22.6807 15.7902C22.8226 16.0741 22.7076 16.4193 22.4237 16.5612L20.3676 17.5893C20.0837 17.7312 19.7385 17.6161 19.5966 17.3322L15.4444 9.02792C15.2327 8.60435 14.6282 8.60435 14.4164 9.02792L10.2643 17.3322C10.1223 17.6161 9.77711 17.7312 9.49323 17.5893L7.43716 16.5612C7.15328 16.4193 7.03821 16.0741 7.18016 15.7902L14.4164 1.31768Z",
		fill: "#CC00CC"
	})]
});
export default SvgTbExtrm;
